<template>
  <div
    class="tab-pane fade"
    :class="{ active: 'Trades' === activeMenuSelection, show: 'Trades' === activeMenuSelection }"
    id="Trades"
    role="tabpanel"
    aria-labelledby="Trades-tab"
  >
    <div class="card h-100">
      <div class="card-body">
        <div class="container" style="background-color: white">
          <div class="row">
            <div class="col-sm-10">
              <div class="collapse" :class="{ show: showFilters }" id="collapseTradesFilters">
                <div class="card card-body wallet-filter-panel">
                  <h5 class="card-title">{{ t("filtersLabel") }}</h5>
                  <label for="filterTradesByOrderType">{{ t("orderTypeLabel") }}</label>
                  <select id="filterTradesByOrderType" class="form-select form-select-sm mb15" v-model="selectedOrderType">
                    <option value="0">{{ t("allOrderTypesLabel") }}</option>
                    <option value="1">{{ t("buyLabel") }}</option>
                    <option value="2">{{ t("sellLabel") }}</option>
                  </select>
                  <label for="filterByTradePeriod">{{ t("periodLabel") }}</label>
                  <select id="filterByTradePeriod" class="form-select form-select-sm mb15" v-model="selectedPeriod">
                    <option value="0">{{ t("thisMonthLabel") }}</option>
                    <option value="1">{{ t("past3MonthLabel") }}</option>
                    <option value="2">{{ t("past6MonthLabel") }}</option>
                    <option value="3">{{ t("pastYearLabel") }}</option>
                    <option value="4">YTD</option>
                    <option value="5">{{ t("fromDateLabel") }}</option>
                  </select>
                  <Datepicker
                    class="mb15"
                    v-if="5 === parseInt(filterTradesByPeriod)"
                    v-model="selectedDate"
                    format="yyyy-MM-dd"
                    placeholder="yyyy-mm-dd"
                    :minDate="new Date(minDateForWallet)"
                    :maxDate="new Date()"
                    showNowButton
                  />
                  <button type="button" class="btn btn-primary w-100" @click.prevent="$emit('reset-filters')">
                    {{ t("clearLabel") }}
                  </button>
                </div>
              </div>
              <div class="collapse" :class="{ show: showSorting }" id="collapseTradesSorting">
                <div class="card card-body wallet-filter-panel">
                  <label for="sortingTrades">{{ t("sortingLabel") }}</label>
                  <select id="sortingTrades" class="form-select form-select-sm mb15" v-model="selectedSort">
                    <option value="0">{{ t("sortDateAscLabel") }}</option>
                    <option value="1">{{ t("sortDateDescLabel") }}</option>
                    <option value="2">{{ t("sortSymbolAscLabel") }}</option>
                    <option value="3">{{ t("sortSymbolDescLabel") }}</option>
                    <option value="4">{{ t("sortNameAscLabel") }}</option>
                    <option value="5">{{ t("sortNameDescLabel") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="wallet-tab-actions">
                <button
                  type="button"
                  class="btn btn-link"
                  :class="{ active: showSorting }"
                  :aria-expanded="showTradesSorting"
                  aria-controls="collapseTradesSorting"
                  @click.prevent="toggleSorting"
                >
                  <img class="wallet-toolbar-icon" src="@/assets/images/sort.svg" alt="" />
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  :class="{ active: showFilters }"
                  :aria-expanded="showTradesFilters"
                  aria-controls="collapseTradesFilters"
                  @click.prevent="toggleFilters"
                >
                  <img class="wallet-toolbar-icon" src="@/assets/images/filter.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="wallet-history">
          <div v-if="loading" class="wallet-history-loading">
            <Preloader />
          </div>
          <div v-else-if="1200 < windowsWidth" class="table-responsive">
            <table class="table trades-table">
              <thead>
                <tr>
                  <th class="trade-id-column">{{ t("orderLabel") }}</th>
                  <th class="timestamp-data">{{ t("timestampLabel") }}</th>
                  <th class="trade-center-column trade-type-column">{{ t("typeLabel") }}</th>
                  <th class="trade-center-column trade-order-type-column">{{ t("orderTypeLabel") }}</th>
                  <th class="trade-center-column">{{ t("codeLabel") }}</th>
                  <th class="trade-name-column">{{ t("nameLabel") }}</th>
                  <th class="price-data">{{ t("quantityLabel") }}</th>
                  <th class="price-data trade-price-column">{{ t("priceLabel") }}</th>
                  <th class="price-data trade-total-column">{{ t("totalAmountLabel") }}</th>
                  <th class="trades-action-cell"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction, index) in trades" :key="index">
                  <td class="trade-id-column">#{{ transaction.oid }}</td>
                  <td class="timestamp-data">{{ getDate(transaction.ts) }}</td>
                  <td class="trade-center-column trade-type-column">{{ capitalizeFirstLetter(getOrderType(transaction?.tt)) }}</td>
                  <td class="trade-center-column trade-order-type-column">{{ getBackendOrderType(transaction?.ot) }}</td>
                  <td class="trade-center-column">{{ transaction.sc.toUpperCase() }}</td>
                  <td
                    class="trade-name-column"
                    :aria-label="0 === 'BG'.localeCompare(userLanguage) ? (transaction?.nBG ? transaction?.nBG : transaction?.nEN) : transaction?.nEN"
                    @mouseenter="setNameTooltip"
                  >
                    <div class="name-tooltip-wrapper">
                      <div class="name-truncated-text" v-if="0 === 'BG'.localeCompare(userLanguage)">
                      {{ transaction?.nBG ? transaction?.nBG : transaction?.nEN }}
                    </div>
                      <div class="name-truncated-text" v-if="0 === 'EN'.localeCompare(userLanguage)">{{ transaction?.nEN }}</div>
                    </div>
                  </td>
                  <td class="price-data">{{ parseNumber(transaction?.qty, 0) }}</td>
                  <td class="price-data trade-price-column" v-if="2 != getStockTypeId(transaction.code, transaction.xcode)">
                    {{ formatPrice(transaction?.sp, transaction?.cc).replace(" ", "&nbsp;") }}
                  </td>
                  <td class="price-data trade-price-column" v-else>
                    {{ formatBondsPrice(transaction?.sp).replace(" ", "&nbsp;") }}
                  </td>
                  <td class="price-data trade-total-column">
                    {{ formatPrice(transaction?.pt, transaction?.cc).replace(" ", "&nbsp;") }}
                  </td>
                  <td class="trades-action-cell">
                    <button
                      type="button"
                      class="btn btn-primary"
                      :class="{ 'xsmall-font-size': 1200 > windowsWidth }"
                      @click.prevent="$emit('open-trade-details', transaction)"
                    >
                      &rarr;
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else v-for="(transaction, index) in trades" :key="index">
            <div class="card h-100">
              <div class="card-body xsmall-font-size">
                <div class="container p-0">
                  <div class="row justify-content-between">
                    <div class="col-6">
                      #{{ transaction.oid }}<br />
                      {{ getDate(transaction.ts) }}<br />
                      {{ transaction.sc.toUpperCase() }}@{{ transaction.xc.toUpperCase() }}<br />
                      {{ getBackendOrderType(transaction?.ot) }}
                    </div>
                    <div class="col-6 text-end my-auto">
                      <button
                        type="button"
                        class="btn btn-primary"
                        :class="{ 'xsmall-font-size': 1200 > windowsWidth }"
                        @click.prevent="$emit('open-trade-details', transaction)"
                      >
                        &rarr;
                      </button>&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import Preloader from "@/components/ui/Preloader.vue";

export default {
  name: "WalletTradesTab",
  components: {
    Datepicker,
    Preloader
  },
  props: {
    activeMenuSelection: {
      type: String,
      required: true
    },
    trades: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    windowsWidth: {
      type: Number,
      required: true
    },
    userLanguage: {
      type: String,
      required: true
    },
    minDateForWallet: {
      type: String,
      required: true
    },
    filterSelectedDate: {
      type: [Date, String, Number, Object],
      default: null
    },
    filterTradesByOrderType: {
      type: [Number, String],
      required: true
    },
    filterTradesByPeriod: {
      type: [Number, String],
      required: true
    },
    sortTrades: {
      type: [Number, String],
      required: true
    },
    showTradesFilters: {
      type: Boolean,
      required: true
    },
    showTradesSorting: {
      type: Boolean,
      required: true
    },
    translator: {
      type: Function,
      required: true
    },
    priceFormatter: {
      type: Function,
      required: true
    },
    bondsPriceFormatter: {
      type: Function,
      required: true
    },
    numberParser: {
      type: Function,
      required: true
    },
    dateFormatter: {
      type: Function,
      required: true
    },
    capitalizeFormatter: {
      type: Function,
      required: true
    },
    orderTypeFormatter: {
      type: Function,
      required: true
    },
    backendOrderTypeFormatter: {
      type: Function,
      required: true
    },
    stockTypeResolver: {
      type: Function,
      required: true
    }
  },
  emits: [
    "update:filterSelectedDate",
    "update:filterTradesByOrderType",
    "update:filterTradesByPeriod",
    "update:sortTrades",
    "update:showTradesFilters",
    "update:showTradesSorting",
    "reset-filters",
    "open-trade-details"
  ],
  computed: {
    selectedDate: {
      get() {
        return this.filterSelectedDate;
      },
      set(value) {
        this.$emit("update:filterSelectedDate", value);
      }
    },
    selectedOrderType: {
      get() {
        return this.filterTradesByOrderType;
      },
      set(value) {
        this.$emit("update:filterTradesByOrderType", value);
      }
    },
    selectedPeriod: {
      get() {
        return this.filterTradesByPeriod;
      },
      set(value) {
        this.$emit("update:filterTradesByPeriod", value);
      }
    },
    selectedSort: {
      get() {
        return this.sortTrades;
      },
      set(value) {
        this.$emit("update:sortTrades", value);
      }
    },
    showFilters() {
      return true === this.showTradesFilters;
    },
    showSorting() {
      return true === this.showTradesSorting;
    }
  },
  methods: {
    setNameTooltip(event) {
      const wrapper = event.currentTarget.querySelector(".name-tooltip-wrapper");
      const content = wrapper?.querySelector(".name-truncated-text");
      const name = content?.textContent.trim();

      if (content && content.scrollWidth > content.clientWidth) {
        wrapper.setAttribute("data-tooltip", name);
      } else {
        wrapper?.removeAttribute("data-tooltip");
      }
    },
    t(key, ...args) {
      return this.translator(key, ...args);
    },
    formatPrice(...args) {
      return this.priceFormatter(...args);
    },
    formatBondsPrice(...args) {
      return this.bondsPriceFormatter(...args);
    },
    parseNumber(...args) {
      return this.numberParser(...args);
    },
    getDate(...args) {
      return this.dateFormatter(...args);
    },
    capitalizeFirstLetter(...args) {
      return this.capitalizeFormatter(...args);
    },
    getOrderType(...args) {
      return this.orderTypeFormatter(...args);
    },
    getBackendOrderType(...args) {
      return this.backendOrderTypeFormatter(...args);
    },
    getStockTypeId(...args) {
      return this.stockTypeResolver(...args);
    },
    toggleFilters() {
      this.$emit("update:showTradesFilters", !this.showTradesFilters);
      this.$emit("update:showTradesSorting", false);
    },
    toggleSorting() {
      this.$emit("update:showTradesSorting", !this.showTradesSorting);
      this.$emit("update:showTradesFilters", false);
    }
  }
};
</script>

<style scoped>
.wallet-tab-actions {
  display: flex;
  gap: 0.25rem;
  justify-content: flex-end;
}

.wallet-tab-actions .icon {
  color: #000000;
  font-size: 15px;
  line-height: 1;
}

.wallet-tab-actions .wallet-toolbar-icon {
  height: 18px;
  width: 18px;
}

.wallet-tab-actions .btn-link {
  align-items: center;
  border: 1px solid transparent;
  display: inline-flex;
  justify-content: center;
  min-height: 2rem;
  min-width: 2rem;
  padding: 0.25rem 0.5rem;
}

.wallet-tab-actions .btn-link:focus,
.wallet-tab-actions .btn-link:focus-visible {
  box-shadow: none;
  outline: 0;
}

.wallet-tab-actions .btn-link.active {
  border-color: #0088aa;
}

.wallet-history-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 8rem;
}

.trades-table {
  table-layout: fixed;
  width: 100%;
}

.trade-id-column {
  max-width: 10%;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 10%;
}

.trade-center-column {
  text-align: center;
  width: 7%;
  white-space: nowrap;
}

.trade-order-type-column {
  width: 12%;
  white-space: nowrap;
}

.trade-name-column {
  max-width: 15%;
  overflow: visible;
  position: relative;
  text-align: left;
  width: 15%;
}

.name-tooltip-wrapper {
  min-width: 0;
  position: relative;
  width: 100%;
}

.name-truncated-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name-tooltip-wrapper[data-tooltip]::after {
  background: #0088aa;
  border-radius: 0.25rem;
  color: #ffffff;
  content: attr(data-tooltip);
  left: 0;
  max-width: none;
  opacity: 0;
  padding: 0.35rem 0.5rem;
  pointer-events: none;
  position: absolute;
  bottom: calc(100% + 0.25rem);
  transition: opacity 0.15s ease-in-out;
  visibility: hidden;
  width: max-content;
  white-space: nowrap;
  z-index: 10;
}

.name-tooltip-wrapper[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
}

.trades-action-cell {
  padding-left: 0;
  padding-right: 0;
  text-align: right;
  vertical-align: middle;
  width: 3rem;
}

.price-data {
  text-align: right;
  white-space: nowrap;
  width: 7%;
}

.trade-price-column,
.trade-total-column {
  text-align: right;
}

.trade-price-column {
  width: 9%;
}

.trade-total-column {
  width: 11%;
}

.timestamp-data {
  text-align: left;
  white-space: nowrap;
  width: 16%;
}
</style>
